<template>
    <div :data-time="cpntTime" v-if="[ '', 0, '0', null, undefined ].indexOf(cpntTime) === -1">
        <table class="cabecalho">
            <tr>
                <td class="logo">
                    <img :src="$store.state.logotipo" :alt='$store.state.licenca.rSocial'/>
                </td>
                <td class="dados">
                    <div>
                        <!-- <span class="titulo">Razão Social:</span> -->
                        <span class="valor" v-html='$store.state.licenca.rSocial'></span>
                    </div>
                    <div>
                        <!-- <span class="titulo">CNPJ:</span> -->
                        <span class="valor" v-html='$store.state.licenca.cnpj'></span>
                    </div>
                    <div>
                        <!-- <span class="titulo">Telefone:</span> -->
                        <span class="valor" v-html='$store.state.licenca.telefone'></span>
                    </div>
                    <div>
                        <!-- <span class="titulo">CEP:</span> -->
                        <span class="valor" v-html='$store.state.licenca.cep'></span>
                    </div>
                    <div>
                        <!-- <span class="titulo">Endereço:</span> -->
                        <span class="valor" v-html='$store.state.licenca.endereco'></span>
                        <span class="valor" v-html='", "'></span>
                        <span class="valor" v-html='$store.state.licenca.numero'></span>
                        <span class="valor" v-html='" (" + $store.state.licenca.complemento + ")"' v-if="[ '', null, undefined ].indexOf($store.state.licenca.complemento) === -1"></span>
                    </div>
                    <div>
                        <!-- <span class="titulo">Bairro:</span> -->
                        <span class="valor" v-html='$store.state.licenca.bairro'></span>
                    <div>
                    </div>
                        <!-- <span class="titulo">Cidade/UF:</span> -->
                        <span class="valor" v-html='$store.state.licenca.cidade + "/" + $store.state.licenca.uf'></span>
                    </div>
                </td>
                <td class="info">
                    <div class="titulo" v-if="[ '', null, undefined ].indexOf(cpntNome) === -1" v-html="cpntNome"></div>
                    <slot name="rel-nome"></slot>
                </td>
            </tr>
        </table>

        <hr class="separador">
    </div>
</template>

<style scoped>
.cabecalho {
    width: 100%;
    border-spacing: none;
}
    .cabecalho > tr > td {
        text-align: left;
        padding: 5px;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }
        .cabecalho > tr > td.info {
            border-right: 1px solid #ccc;
            text-align: center
        }
        .cabecalho > tr > td.info > .titulo {
            text-align: center;
            text-transform: uppercase;
            font-weight: 600;
            
            font-size: var(--font-base-soma-16);
        }
        .cabecalho > tr > td.logo {
            width: 200px;
            padding: 0px 10px;
            border-left: 1px solid #ccc;
        }
        .cabecalho > tr > td.dados {
            width: 320px;
            text-align: left !important;
        }
            .cabecalho > tr > .dados > div {
                text-align: left;
            }
            .cabecalho > tr > .dados > div > .titulo,
            .cabecalho > tr > .dados > div > .valor {
                margin-left: 3px;
                font-size: var(--font-base-soma-12);
                line-height: 16px;
            }
            .cabecalho > tr > .dados > div > .titulo {
                display: none;
                font-size: var(--font-base-soma-11);
                line-height: 14px;
                /* color: #777; */
                color: #3c4e71;
            }



.separador {
    margin: 20px 0px;
}
</style>

<script>
export default {
    props: {
        cpntTime: {
            required: true
        },
        cpntNome: {
            required: false,
            type: String
        }
    }
}
</script>